import { Box, useTheme } from '@mui/material';
import { ActivityItem } from '@/modules/lead-page/dtos/index-v2';
import { CallSummaryTab } from '@/modules/analytics/types';
import ZoomCallDetailBody from '@/modules/zoom-calls/components/zoom-call-detail-body';

interface Props {
	zoomCallUid: string;
	activityItem: ActivityItem;
	onTabChange?: (tab: CallSummaryTab) => void;
}

const ZoomCallPanel = ({ zoomCallUid, activityItem, onTabChange }: Props) => {
	const theme = useTheme();

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				width: '100%',
				height: '100%',
				overflow: 'hidden',
				backgroundColor: theme.nawy.colors.semantic.layer.primary,
			}}
		>
			<Box
				sx={{
					flex: 1,
					overflowY: 'auto',
					p: theme.nawy.spacing.md,
					'&::-webkit-scrollbar': { width: 6 },
					'&::-webkit-scrollbar-thumb': {
						background: theme.nawy.colors.semantic.border.secondary,
						borderRadius: 3,
					},
				}}
			>
				<ZoomCallDetailBody
					zoomCallUid={zoomCallUid}
					activityItem={activityItem}
					onTabChange={onTabChange}
				/>
			</Box>
		</Box>
	);
};

export default ZoomCallPanel;
